import { t } from 'i18next'
import { Context } from 'react'
import { AuthorizationProvider } from 'src/components/common/Authorization'
import OverallReport from 'src/components/overallReport/OverallReport'
import { AuthorizationType } from 'src/enums/auth'
import { permissionValue } from 'src/enums/permissionValue'
import { ILocality } from 'src/generated-types'
import { useMainComponentReportFormInitialValues } from 'src/screens/localities/utils/localityReportFormDefaults'
import { formSchemaReportTypes } from 'src/generated-types/form-schema'
import { IMainComponent } from 'src/generated-types/main-component'

interface Props {
  context: Context<any> | null | undefined
  mainComponentId: any
  mainComponent: IMainComponent | undefined
  locality: ILocality | undefined
  localityId?: EntityId
  height?: number | string
  autoHeight?: boolean
  maxVisibleRowCount?: number
  minimalEmptyStatus?: boolean
  setDataLength?: (length: number) => void
  isReadOnly?: boolean
}

const ReportInEquipment: React.FC<Props> = props => {
  const {
    context,
    mainComponentId,
    mainComponent,
    locality,
    localityId,
    height,
    autoHeight,
    maxVisibleRowCount,
    minimalEmptyStatus,
    setDataLength,
    isReadOnly,
  } = props
  const reportFormInitialValues = useMainComponentReportFormInitialValues(mainComponent, locality)

  return (
    <AuthorizationProvider
      type={AuthorizationType.Disabled}
      Context={context}
      permissions={[
        permissionValue.ServiceStation.Read,
        permissionValue.Locality.MainComponent.Report.Read,
        permissionValue.ClientAdminPermission,
        permissionValue.ClientAdminPortal.Equipment_Portal,
      ]}
    >
      <OverallReport
        type={formSchemaReportTypes.MainComponent}
        mainComponentId={mainComponentId}
        localityId={locality?.id ?? mainComponent?.selectedLocalityId ?? localityId}
        customerId={mainComponent?.customerId as EntityId}
        context={context}
        formInitialValues={reportFormInitialValues}
        createPermissions={[
          permissionValue.Locality.MainComponent.Report.Write,
          permissionValue.ServiceStation.Write,
          permissionValue.ClientAdminPermission,
          permissionValue.ClientAdminPortal.Equipment_Portal,
        ]}
        deletePermissions={[
          permissionValue.Locality.MainComponent.Report.Delete,
          permissionValue.ServiceStation.Delete,
          permissionValue.ClientAdminPermission,
          permissionValue.ClientAdminPortal.Equipment_Portal,
        ]}
        height={height}
        autoHeight={autoHeight}
        maxVisibleRowCount={maxVisibleRowCount}
        listView={true}
        emptyStatusImageWidth="90px"
        emptyStatusContent={t('reports-empty-status-content', { ns: 'equipment' })}
        emptyStatusTitle={t('reports-empty-status-title', { ns: 'equipment' })}
        emptyStatusTitleFontSize="18px"
        emptyStatusContentFontSize="14px"
        emptyStatusContentClass="mt-2"
        imageContainerClasses="pb-4 pt-0"
        withoutLayout={true}
        iconWidth="16px"
        tableRowHeight={36}
        actionButtonheightAndWidth="24px"
        minimalEmptyStatus={minimalEmptyStatus}
        useCustomSpinner={true}
        setDataLength={setDataLength}
        disabled={isReadOnly}
        enableMoveReport={true}
      />
    </AuthorizationProvider>
  )
}

export default ReportInEquipment
